<template>
	<div>
		<div class="Addamand">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			  <el-form-item label="需求标题" prop="name">
				<el-input v-model="ruleForm.name"></el-input>
			  </el-form-item>
			  <el-form-item label="选择行业" prop="value">
				<el-select v-model="ruleForm.value"   
						   multiple
				  :multiple-limit="5" 
						   placeholder="请选择行业，最多选择五个" style="width:100%;">
				   <el-option :label="i.name || i.dict_label" :value="i.dict_value || i.value || i.name" v-for="(i,index) in industry" :key="index"></el-option>
				</el-select>
			  </el-form-item>
			  <el-form-item label="详细描述" prop="description">
				<el-input type="textarea" v-model="ruleForm.description"></el-input>
			  </el-form-item>
			  <el-form-item label="报价截止时间" >
				<el-col :span="24">
				  <el-form-item>
					 <el-date-picker
						 v-model="ruleForm.end_time"
						  style="width: 100%;"
						  type="datetime"
						  placeholder="选择日期时间">
						</el-date-picker>
				  </el-form-item>
				   <p  style="color: #FF0000;font-size:12px;">如您未设置时间，报价将会<span>{{demand_off_time || '24'}}</span>时后自动截止并关闭需求</p>
				</el-col>
			  </el-form-item>
			  <el-form-item label="附件上传" v-if="demand_file_config==1">
				   <el-upload
					 class="upload-demo"
					 :action="uploadActionUrl"
					 :on-remove="handleRemove"
					 :on-success="handleUploadSuccess"
					 :before-remove="beforeRemove"
					  :multiple='false'
					 :limit="4"
					 :on-exceed="handleExceed"
					 :file-list="fileList">
					 <div>
						<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
						<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
							 单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf，zip文件类型
						</span>
					 </div>
				   </el-upload>
			  </el-form-item>
			</el-form>
			<div>
				<p style="width:100%;text-align:center;color: #FF0000;font-size:14px;">发布需求后需要平台审核，自动过审时间为{{demand_auto_pass || '24'}}小时</p>
				<div class="fbfooter">
					 <div class="fbfooter1" @click="quxiao">取消</div> 
					 <div class="fbfooter2" @click="submitForm('ruleForm')">立即提交</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import config from '@/config/index'
	import {dictValue,DemandAdd,DemandDetail,BaseGetConfig,personal,Demandupdate} from "@/api/api.js"
	
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		  baseURL:config.baseURL,
		  centerDialogVisible:false,
		  ruleForm: {
			value:[],
			i_ids:"",
			name: '',
			description:"",
			end_time:"",
			file:[]
		  },
		  fileList:[],
		  userinfo:"",
		  rules: {
			name: [
			  { required: true, message: '请输入需求标题', trigger: 'blur' },
			],
			value: [
			  { required: true, message: '请选择行业', trigger: 'blur' }
			],
			description: [
			  { required: true, message: '请填写需求详情', trigger: 'blur' }
			]
		  },
		  demand_file_config:"",
		  demand_off_time:"",
		  industry:[],
		  demand_auto_pass:"",
		  datails:"",
		  valiFormData:[],
		  content_image:[]
	    }
	  },
	  watch:{
		  centerDialogVisible:{
			  handler(newValue){
				  if(newValue==false){
						this.ruleForm.value=[]
						this.ruleForm.i_ids=""
						this.ruleForm.name=""
						this.ruleForm.description=""
						this.ruleForm.end_time=""
						this.ruleForm.file=[]
						this.fileList=[]
					  }
				  },
				 deep:true
			}
	  	},
	  computed: {
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
			// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			},
			d_id(){
				return this.$route.query.d_id || ''
			}
	  },
	  mounted() {
		this.getdictValue()
	     if(this.d_id){
	     	this.getDemandDetail()
	     }
	  },
	  created() {
	  	 this.getpersonal()
		 this.getBaseGetConfig()
	  },
	  methods: {
		  quxiao(){
			  this.$router.go(-1)
		  },
		 getFileNameFromUrl(url){
		 	if(!url || typeof url !== 'string') return ''
		 	const cleanUrl = url.split('?')[0]
		 	const parts = cleanUrl.split('/')
		 	return parts[parts.length - 1] || ''
		 },
		 getDemandDetail(){
		 	this.content_image=[]
		 	DemandDetail(this.d_id,{}).then(res=>{
		 		this.datails=res.data.data
		 		this.ruleForm.description=this.datails.description
		 		this.ruleForm.name=this.datails.name
		 		this.fileList=[]
		 		if(Array.isArray(this.datails.file) && this.datails.file.length>0){
		 			this.datails.file.forEach((item,index)=>{
		 				 const fileItem = {
		 				 	uid: `history-${index}`,
		 				 	name: this.getFileNameFromUrl(item),
							response:{
								data:item
							},
		 				 	status: 'success'
		 				 }
		 				 this.content_image.push({ url:item })
		 				 this.fileList.push(fileItem)
		 			})
		 		}
		 		this.ruleForm.file = Array.isArray(this.datails.file) ? [...this.datails.file] : []
				console.log(this.industry)
		 		// 多选：将已选值设置为数组（以 dict_value 为准），i_ids 为逗号分隔的字符串
		 		const selected = this.industry.filter(item => (this.datails.industries || []).includes(item.name))
		 		this.ruleForm.value = selected.map(item => item.dict_value)
		 		this.ruleForm.i_ids = this.ruleForm.value.join(",")
		 		console.log(this.ruleForm.value,this.ruleForm.i_ids)
		 	})
		 },
		  
		handleExceed(files, fileList) {
		  this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.ruleForm.file.includes(uploadedUrl)
			if (!exists) this.ruleForm.file.push(uploadedUrl)
		  }
		  console.log(this.fileList)
		},
		beforeRemove(file, fileList) {
			this.fileList = fileList
		},
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.ruleForm.file = this.ruleForm.file.filter((url) => url !== removedUrl)
		},
		getdictValue(){
		  	dictValue({
		  		key:"industry"
		  	}).then(res=>{
		  		this.industry=res.data.data.industry
		  		// this.work_year.forEach(item =>{
		  		// 	item.text=item.name
		  		// })
		  	})
		},
		getBaseGetConfig(){
		  	BaseGetConfig({
		  		key:"demand_file_config,demand_off_time,demand_auto_pass"
		  	}).then(res=>{
		  		this.demand_file_config=res.data.data.demand_file_config
		  		this.demand_off_time=res.data.data.demand_off_time
				this.demand_auto_pass=res.data.data.demand_auto_pass
		  	})
		},
		getpersonal(){
			personal({}).then(res=>{
				this.userinfo=res.data.data
				localStorage.setItem("userinfo",this.userinfo)
			})
		},
		xuqiu(){
			 this.centerDialogVisible=true
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			    // this.DemandAdd(this.ruleForm)
				this.setDemandAdd()
			  } else {
			    console.log('error submit!!')
			    return false
			  }
			})
		},
		setDemandAdd(){
			this.ruleForm.file=[]
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
                    this.ruleForm.file.push(res.response.data)
				})
			}
			this.ruleForm.i_ids=this.ruleForm.value.join()
			console.log(this.ruleForm)
			if(!this.d_id){
				DemandAdd({
					...this.ruleForm
				}).then(res=>{
					if(res.data.status==200){
						this.$message.success('提交成功');
						this.$router.go(-1)
					}else{
						// this.$message.error(res.data.msg);
					}
				})
			}else{
				// 再次发布
				if(this.type==2){
					DemandAdd({
						...this.ruleForm
					}).then(res=>{
						if(res.data.status==200){
							this.$message.success('提交成功');
							this.$router.go(-1)
						}else{
							// this.$message.error(res.data.msg);
						}
					})
				}else{
					// 重新发布
					Demandupdate({
						d_id:this.d_id,
						...this.ruleForm
					}).then(res=>{
						if(res.data.status==200){
							this.$message.success('提交成功');
							this.$router.go(-1)
						}else{
							// this.$message.error(res.data.msg);
						}
					})
				}
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		message(){
			if (this.$route.path !== '/demandHome/messagelist') {
			    this.$router.push('/demandHome/messagelist')
			}
		}
	  },
	}
</script>

<style scoped>
	.Addamand{
		width:1200px;
		margin:0 auto;
		padding:24px;
		background-color:#fff;
		border-radius:12px;
		margin-top:30px;
	}
	.nav-item .el-icon-arrow-down {
	  font-size: 14px;
	  margin-left: 4px;
	}
	::v-deep .el-dropdown{
		color:#999999;
	}
	::v-deep .active-link{
	    color: #1E3A8A !important;
	}
	::v-deep .el-dialog__body {
	    padding: 0px 20px 20px;
	}
	::v-deep .el-dialog{
		border-radius:6px !important;
	}
	.fbfooter{
		display:flex;
		justify-content:center;
		align-items: center;
	}
	.fbfooter div{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		display:flex;
		align-items:center;
		justify-content:center;
		margin:20px;
		cursor:pointer;
		color:#1E3A8A;
	}
	.fbfooter2{
		background: #1E3A8A !important;
		color:#fff !important;
	}
	.disng{
		display:flex;
		align-items: center;
	}
	.disng1{
		width:24px;
		height:24px;
		margin-left:24px;
		cursor:pointer;
	}
	.disng2{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-left:24px;
		cursor:pointer;
	}
</style>